import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dianying', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-background-50 text-xl"></i>
            </div>
            <span
              className={`font-heading font-bold text-lg whitespace-nowrap transition-colors ${
                scrolled ? 'text-foreground-900' : 'text-white'
              }`}
            >
              黄瓜视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : scrolled
                    ? 'text-foreground-700'
                    : 'text-white/90'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors ${
                scrolled
                  ? 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  : 'bg-white/20 text-white hover:bg-white/30'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
              scrolled
                ? 'text-foreground-700'
                : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`block py-3 text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === link.to
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-3 border-t border-background-200/70 mt-3">
            <button className="flex items-center gap-2 text-sm text-foreground-600 py-2">
              <i className="ri-search-line"></i>
              <span>搜索视频</span>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}